import * as React from "react";

import Container from "@client/content/Containers/container";
import withStyleSheets from "@client/content/Containers/withStyleSheets";
import { getContainerProps, getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import ListItemContainer from "./Item/container";

import "./style.less";

export type ListsContainerProps = RootContainerProps & {
  className: string;
  containerStyle: React.CSSProperties;
  itemsIds: string[];
};

const ItemsContainer = withStyleSheets<React.HTMLProps<HTMLDivElement>>((props) => <div {...props} />, ["text"]);

export default ({ className, itemsIds, containerStyle, ...props }: ListsContainerProps) => (
  <Container className={className} {...getContainerProps(props)}>
    {/* <ContentTextStyle id={props.id} textSubSelector=".list-icon-item" /> */}

    <ItemsContainer
      {...getEntityRef(props)}
      className="items_container"
      style={containerStyle}
      textSubSelector=".list-icon-item"
    >
      {itemsIds.map((id, i) => (
        <ListItemContainer key={id} {...getRootContainerProps(props)} parentId={props.id} id={id} />
      ))}
    </ItemsContainer>
  </Container>
);
